import "../../../../src/pages/reference/css/lineLoss-styles.css";
import * as React from 'react';
export default {
  React
};